<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <van-list v-if="collectList.length"  v-model="loading" :finished="finished" :immediate-check="noimmediate" :finished-text="finishedTxt" @load="moreList">
      <div class="list">
        <div class="item left-justifying" v-for="(item,index) in collectList" :key="index" style="align-items: self-start;" @click="goGoodDes(item.goods.id)">
          <img :src="item.goods.image" alt="" />
          <div class="content">
            <div class="title">{{item.goods.name}}</div>
            <div class="price">￥{{item.goods.price}}</div>
          </div>
        </div>
      </div>
    </van-list>
    <div style="text-align: center;margin-top: 20vw;" v-else>暂无数据</div>
  </div>
</template>

<script>
import { collectList } from '@/api/goods'
export default {
  name: "collect",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      collectList: [],
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      noimmediate:false,
      finishedTxt: '没有更多了~',
      statusType: 'null'
    }
  },
  created() {
    this.finished = false
    this.getList()
  },
  methods: {
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    goGoodDes(id){
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
    getList(){
      var that = this
      var data = {
        page:1
      }
      collectList(data).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data.length+'total',res.data.total)
          that.collectList = res.data.data
          // 加载状态结束
          this.loading = false;
          if (res.data.data.length == res.data.total){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            console.log('加载完毕')
            if(res.data.data==0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 不可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      collectList(data).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data)
          var arr = this.collectList.concat(res.data.data);
          // console.log(arr.length)
          that.ocollectList = arr
          // 加载状态结束
          this.loading = false;
          if (that.collectList.length == res.data.total) { // 数据全部加载完成
            this.finished = true;
            // console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.list{
  padding: 0 24px;
  .item{
    position: relative;background: #ffffff;border-radius: 25px;padding: 20px;margin-top: 20px;
    img{
      width: 200px;height: 200px;display: inline-block;margin-right: 20px;
    }
    .content{
      font-size: 28px;color: #000000;
      .title{
        text-align: left;
      }
    }
    .price{
      font-size: 32px;
      font-weight: bold;
      color: #F23926;position: absolute;bottom: 20px;left: 240px;
    }

  }

}
</style>
